import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmarkPlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBookmarkPlus"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V22.7232L12 18.1518L20 22.7232V2H4ZM13 6V9H16V11H13V14H11V11H8V9H11V6H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookmarkPlus;
